import {
  CLOSE_AMEND_APPOINTMENT_MODAL,
  UPDATE_APPOINTMENT_DATE_AND_TIME,
  FETCH_ORDER_PREAPPOINTMENTS_START,
  FETCH_ORDER_PREAPPOINTMENTS_SUCCEED,
  SET_NOTIFICATION_TYPE,
  HIDE_NOTIFICATION,
  SHOW_ADD_NEW_CONTACT_FORM,
  SET_IS_READY_TO_CONFIRM,
  INIT_AMEND_APPOINTMENT_FLOW_SUCCEED,
  SELECT_SITE_CONTACT,
  ADD_NEW_SITE_CONTACT,
  SET_CURRENT_APPOINTMENT_INFO,
  CONFIRM_AMENDS_TO_APPOINTMENT_SUCCEED,
} from '../actions';

interface Contact {
  contactKey: string;
  [key: string]: unknown;
}

interface AppointmentInfo {
  date: string;
  orderId: string;
  itemId: string;
  [key: string]: unknown;
}

interface AmendAppointmentState {
  hasModalOpened: boolean;
  selectedDate: string;
  selectedSlot: string;
  selectedContact: string | number;
  fetching: boolean;
  preAppointments: unknown[];
  firstAvailableAppointmentDate: string;
  notificationType: string;
  contacts: Contact[];
  initialContactKey: string;
  addingNewContact: boolean;
  isReadyToConfirm: boolean;
  slotsType: string;
  confirmedAmends: Record<string, unknown>;
  appointmentInfo: AppointmentInfo;
}

interface Action {
  type: string;
  payload?: unknown;
}

const initialState: AmendAppointmentState = {
  hasModalOpened: false,
  selectedDate: '',
  selectedSlot: '',
  selectedContact: 0,
  fetching: false,
  preAppointments: [],
  firstAvailableAppointmentDate: '',
  notificationType: '',
  contacts: [],
  initialContactKey: '',
  addingNewContact: false,
  isReadyToConfirm: false,
  slotsType: 'AM/PM',
  confirmedAmends: {},
  appointmentInfo: {
    date: '',
    orderId: '',
    itemId: '',
  },
};

export const amendAppointment = (
  state: AmendAppointmentState = initialState, { type, payload }: Action,
): AmendAppointmentState => {
  switch (type) {
    case SET_CURRENT_APPOINTMENT_INFO:
      return {
        ...state,
        appointmentInfo: payload as AppointmentInfo,
      };
    case INIT_AMEND_APPOINTMENT_FLOW_SUCCEED: {
      const flowPayload = payload as { contacts: Contact[]; [key: string]: unknown };
      const initialContactKey = flowPayload.contacts[0].contactKey;
      return {
        ...state,
        ...flowPayload,
        selectedContact: initialContactKey,
        initialContactKey,
        hasModalOpened: true,
      };
    }
    case CLOSE_AMEND_APPOINTMENT_MODAL:
      return {
        ...initialState,
        confirmedAmends: state.confirmedAmends,
      };
    case UPDATE_APPOINTMENT_DATE_AND_TIME:
      return {
        ...state,
        ...(payload as Record<string, unknown>),
      };
    case FETCH_ORDER_PREAPPOINTMENTS_START:
      return {
        ...state,
        fetching: true,
      };
    case FETCH_ORDER_PREAPPOINTMENTS_SUCCEED:
      return {
        ...state,
        ...(payload as Record<string, unknown>),
        fetching: false,
      };
    case SHOW_ADD_NEW_CONTACT_FORM:
      return {
        ...state,
        addingNewContact: payload as boolean,
      };
    case SET_IS_READY_TO_CONFIRM:
      return {
        ...state,
        isReadyToConfirm: payload as boolean,
      };
    case SELECT_SITE_CONTACT:
      return {
        ...state,
        selectedContact: payload as string,
      };
    case ADD_NEW_SITE_CONTACT: {
      const contact = payload as Contact;
      return {
        ...state,
        contacts: [contact, ...state.contacts],
        selectedContact: contact.contactKey,
        addingNewContact: false,
      };
    }
    case CONFIRM_AMENDS_TO_APPOINTMENT_SUCCEED: {
      const confirmPayload = payload as { itemId: string; amendsInfo: unknown };
      return {
        ...initialState,
        confirmedAmends: {
          ...state.confirmedAmends,
          [confirmPayload.itemId]: confirmPayload.amendsInfo,
        },
      };
    }
    case SET_NOTIFICATION_TYPE:
      return {
        ...state,
        notificationType: payload as string,
      };

    case HIDE_NOTIFICATION: {
      return {
        ...state,
        notificationType: '',
      };
    }
    default:
      return state;
  }
};
